export enum TipoVinculoEnum {
  Lotacao = 1,
  Mandato = 2,
  Permanente = 3,
  Temporario = 4,
  Terceiro = 5
}

export enum TipoVinculoStringEnum {
  Lotacao = 'Lotação',
  Mandato = 'Mandato',
  Permanente = 'Permanente',
  Temporario = 'Temporário - Representa a entidade que o convidou',
  Terceiro = 'Terceiro'
}

export enum StatusVinculoStringEnum {
  AguardandoValidacao = 'Aguardando Validação',
  RetornoParaAtualizador = 'Retorno para o Atualizador – Ajuste proposto pelo Aprovador',
  AguardandoAprovacao = 'Aguardando Aprovação'
}

export enum TipoOperacaoStringEnum {
  Inclusao = 'Inclusão',
  Alteracao = 'Alteração',
  Exclusao = 'Exclusão Lógica'
}
